import {
  UPLOAD_DATA,
  CLEAR_UPLOAD_DATA,
  MATCH_UPLOAD_DATA,
  UPLOAD_FINAL_DATA_START,
  UPLOAD_FINAL_DATA_SUCCESS,
  UPLOAD_FINAL_DATA_FAILED,
  PARSED_FULL_ADDRESS,
  DB_MATCH_START,
  DB_MATCH_SUCCESS,
  DB_MATCH_FAIL,
} from '../actionTypes/upload'

export const initialState = {
  uploadedData: {},
  chunkedData: [],
  finalUploadedData: [],
  matchedData: {},
  isUploading: false,
  isFullAddressParsed: false,
  isDBMatching: false,
  listUploadedData: [],
};

const upload = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_DATA:
      return {
        ...state,
        uploadedData: {...state.uploadedData, ...action.payload},
      };
    case CLEAR_UPLOAD_DATA:
      return {
        ...state,
        uploadedData: {}, // Clear the current chunk of data
        chunkedData: [], // Clear all chunked data
        matchedData: {},
        isFullAddressParsed: false,
      };
    case MATCH_UPLOAD_DATA:
      return {
        ...state,
        matchedData: {
          data: state.uploadedData.data.map(row => {
            let t = {}
            for (let key in row) {
              let c = action.payload.filter(col => col.originalName === key)[0]
              if (c?.confirm === 2) {
                t[c?.matchedName] = row[key]
              } else {
                t[c?.matchedName] = ''
              }
            }
            return t
          })
          ,
          cols: action.payload,
        }
      }
    case UPLOAD_FINAL_DATA_START:
      return {
        ...state,
        isUploading: true,
      };
    case UPLOAD_FINAL_DATA_SUCCESS:
      return {
        ...state,
        isUploading: false,
        finalUploadedData: action.data,
      };
    case UPLOAD_FINAL_DATA_FAILED:
      return {
        ...state,
        isUploading: false,
      };
    case PARSED_FULL_ADDRESS:
      return {
        ...state,
        isFullAddressParsed: action.data,
      };
    case DB_MATCH_START:
      return {
        ...state,
        isDBMatching: true,
      };
    case DB_MATCH_SUCCESS:
      return {
        ...state,
        isDBMatching: false,
        listUploadedData: action?.data && action.data,
      };
    case DB_MATCH_FAIL:
      return {
        ...state,
        isDBMatching: false,
        listUploadedData: [],
      };
    default:
      return state;
  }
};

export default upload
